import { getProductImage } from "./productImages";

const cleanText = (value) =>
  value == null ? "" : String(value).trim();

export const isProductSearchSuggestionEligible = (product) => {
  if (!product || typeof product !== "object") return false;

  const reviewStatus = cleanText(product.nameReviewStatus).toUpperCase();
  if (reviewStatus === "PENDING") return false;

  const hasSiteName = Boolean(cleanText(product.name));
  const hasRealImage = Boolean(getProductImage(product, "thumbnail", 0, ""));

  return hasSiteName && hasRealImage;
};

export default isProductSearchSuggestionEligible;
